import { cn } from '@/shared/utils';
import { HideBalanceSection } from '@/shared/components';

type Props = {
  children: React.ReactNode;
  title: string;
  isBalancesHidden?: boolean;
  setIsBalancesHidden?: () => void;
  hiddenBalancesTitle?: string;
} & React.ComponentProps<'div'>;

const MainPageSection = ({
  title,
  children,
  className,
  isBalancesHidden,
  setIsBalancesHidden,
  hiddenBalancesTitle,
  ...props
}: Props) => {
  return (
    <div
      className={cn(
        'flex flex-col gap-[2.4rem] items-stretch relative',
        className
      )}
      {...props}>
      <span className="hero6 flex flex-row items-start gap-[1.6rem]">
        {title}
        {setIsBalancesHidden && hiddenBalancesTitle && (
          <HideBalanceSection
            isBalancesHidden={Boolean(isBalancesHidden)}
            setIsBalancesHidden={setIsBalancesHidden}
            title={hiddenBalancesTitle}
          />
        )}
      </span>
      {children}
    </div>
  );
};

export { MainPageSection };
